import MobileSearchOrRequestAdvice from './MobileSearchOrRequestAdvice'

export default MobileSearchOrRequestAdvice
